/**
 * Format a number to European currency format
 * Uses dot (.) as thousands separator and comma (,) as decimal separator
 * Examples: €10.000 | €10,99 | €10.345,65
 */
export const formatEuroCurrency = (amount, showSymbol = true) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return showSymbol ? '€0,00' : '0,00';
  }

  const number = parseFloat(amount);

  // Use German locale for European formatting (dot for thousands, comma for decimals)
  const formatted = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number);

  return showSymbol ? `€${formatted}` : formatted;
};

/**
 * Format a number to European format without currency symbol
 * Uses dot (.) as thousands separator and comma (,) as decimal separator
 */
export const formatEuroNumber = (amount) => {
  return formatEuroCurrency(amount, false);
};
